import { IFilterSolicitudAmpliacionSsoModel } from "../interfaces/calendario-sso/IFilterSolicitudAmpliacionSsoModel";

export class FilterSolicitudAmpliacionSsoModel implements IFilterSolicitudAmpliacionSsoModel{
    sedes: number[];
    anio: number;
    meses: number[];
    contratista: string;
    tipos: number[];
    idEstado: number;
    solicitante: string;
    page: number;
    pageSize: number;
    idCompania: number;
    
    constructor(){        
        this.sedes = [];
        this.anio=new Date().getFullYear();
        this.meses = [];
        this.contratista = '';
        this.idEstado = 0;
        this.tipos = [];
        this.solicitante = '';
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}